import type { Rule } from 'antd/es/form';

import i18n from '@/i18n';
import type { DecimalString, ParseError } from '@/lib/decimal';

/** Значение поля, которое не прошло разбор: форма покажет `message` и не отправится. */
export class InvalidQty {
  constructor(
    readonly text: string,
    readonly message: string,
  ) {}
}

/** Текст ошибки разбора на языке интерфейса. */
export function parseErrorText(error: ParseError): string {
  return error.code === 'places'
    ? i18n.t('qty.places', { places: error.places })
    : i18n.t(`qty.${error.code}`);
}

/** Значение QtyInput: строка API, пусто или ошибка ввода. */
export type QtyValue = DecimalString | null | InvalidQty;

/** Правило Form.Item для QtyInput: разбор, обязательность, «больше нуля». */
export function qtyRule({ required = false, positive = false } = {}): Rule {
  return {
    validator: (_rule, value: QtyValue | undefined) => {
      if (value instanceof InvalidQty) return Promise.reject(new Error(value.message));
      if (value === null || value === undefined) {
        return required ? Promise.reject(new Error(i18n.t('qty.required'))) : Promise.resolve();
      }
      if (positive && (value.startsWith('-') || !/[1-9]/.test(value))) {
        return Promise.reject(new Error(i18n.t('qty.positive')));
      }
      return Promise.resolve();
    },
  };
}
